export interface IRangeDateFilterOptions {
  label: 'Últimos 7 dias' | 'Últimos 30 dias' | 'Últimos 60 dias' | string
  quantity: 7 | 30 | 60 | undefined
}

export const rangeDateFilterOptions: IRangeDateFilterOptions[] = [
  {
    label: 'Últimos 7 dias',
    quantity: 7,
  },
  {
    label: 'Últimos 30 dias',
    quantity: 30,
  },
  {
    label: 'Últimos 60 dias',
    quantity: 60,
  },
]
